<template>
  <section class="swpoll-summary">
    <div class="swpoll-summary-head">
      <button class="swpoll-close btn-closesummary" @click="goToPreviousView">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.53032 1.53033C9.82321 1.23744 9.82321 0.762563 9.53032 0.46967C9.23743 0.176777 8.76255 0.176777 8.46966 0.46967L9.53032 1.53033ZM0.46967 8.46967C0.176777 8.76256 0.176777 9.23744 0.46967 9.53033C0.762564 9.82322 1.23744 9.82322 1.53033 9.53033L0.46967 8.46967ZM1.53034 0.46967C1.23745 0.176777 0.762572 0.176777 0.469678 0.46967C0.176785 0.762563 0.176785 1.23744 0.469678 1.53033L1.53034 0.46967ZM8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967L8.46967 9.53033ZM8.46966 0.46967L0.46967 8.46967L1.53033 9.53033L9.53032 1.53033L8.46966 0.46967ZM0.469678 1.53033L8.46967 9.53033L9.53033 8.46967L1.53034 0.46967L0.469678 1.53033Z"
            fill="white"
          />
        </svg>
      </button>
      <h5>Answers Summary</h5>
      <p>
        You had {{ getCorrectAnswersCount }} of
        {{ getTotalAnswersCount }} correct answers
      </p>
    </div>

    <div class="swpoll-summary-body">
      <div class="swpoll-summary-content">
        <div
          class="card-q"
          v-for="(summary, index) in getSummary"
          :key="index + 1"
        >
          <div class="card-q-head">
            <p class="card-q-q"></p>
            <p class="card-q-r">
              <span class="card-q-badge danger" v-if="!summary.correct"
                >Incorrect</span
              >
              <span class="card-q-badge" v-if="summary.correct">Correct</span>
            </p>
          </div>
          <div class="card-q-body">
            <h6>{{ summary.questionText }}</h6>
            <dl>
              <dt>Correct Answer:</dt>
              <dd>{{ summary.correctAnswerText }}</dd>
              <dt v-if="!summary.correct">Your Answer:</dt>
              <dd v-if="!summary.correct">{{ summary.answerText }}</dd>
            </dl>
            <div
              cass="card-q-link"
              v-if="groupArticles && summary.storyLinkURL"
            >
              <a
                :href="summary.storyLinkURL"
                target="_blank"
                class="link-external"
              >
                Learn more about this
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.9999 1.00001L6.24994 9.75001M14.9999 1.00001L15 6.25M14.9999 1.00001L9.74999 1M6.24999 1.00001H1V15H15V9.75"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Summary',
  computed: {
    ...mapGetters('voter', [
      'getCorrectAnswersCount',
      'getTotalAnswersCount',
      'getSummary'
    ]),
    ...mapState('voter', ['previousView']),
    ...mapState('pollGroup', ['groupArticles'])
  },
  methods: {
    ...mapActions('voter', ['switchView']),
    goToPreviousView() {
      this.switchView(this.previousView);
    }
  }
};
</script>

<style scoped lang="scss">
h5 {
  font-size: 1.4rem;
  margin: 0;
}

.swpoll-summary {
  position: relative;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: var(--background-color);
  z-index: 3;
  text-align: center;
}

.swpoll-summary-head,
.swpoll-summary-body {
  // -webkit-transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  // -webkit-transform: translateY(70px);
  //         transform: translateY(70px);
  // opacity: 0;
}

.swpoll-summary .swpoll-close {
  position: absolute;
  right: 55px;
  top: 40px;
}

.swpoll-summary-head {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  padding: 30px 30px 16px 30px;
  width: 100%;
}

.swpoll-summary-head h5 + p {
  margin-top: 4px;
}

.swpoll-summary-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow-y: auto;
  width: 100%;
  padding: 0 16px 30px 16px;
}

@media only screen and (min-width: 600px) {
  .swpoll-summary-content {
    width: 100%;
    max-width: 640px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    margin: 0 auto;
  }
}

.card-q {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;
  text-align: left;
  margin-bottom: 8px;
  // opacity: 0;
  // -webkit-transform: translateY(30px);
  //         transform: translateY(30px);
  // -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transition: -webkit-transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.card-q.makevisible {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.card-q-head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.card-q-head p {
  margin: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

.card-q-q {
  opacity: 0.5;
}

.card-q-r {
  text-align: right;
}

.card-q h6 {
  font-size: 1rem;
  margin: 16px 0;
}

.card-q dt,
.card-q dd {
  padding: 0;
  margin: 0;
}

.card-q dt {
  opacity: 0.7;
}

.card-q dd {
  font-weight: 700;
}

.card-q dd + dt {
  margin-top: 8px;
}

.card-q-badge {
  background-color: var(--success-color);
  color: var(--white);
  font-size: 0.9rem;
  padding: 1px 8px;
  border-radius: 10px;
}

.card-q-badge.danger {
  background-color: var(--danger-color);
}

.card-q-link {
  padding-top: 8px;
}

.link-external {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-column-gap: 4px;
  column-gap: 4px;
  color: var(--answer-color);
  text-decoration: underline;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.link-external svg {
  opacity: 0.7;
}

.link-external:hover {
  text-decoration: none;
}

.swpoll-close {
  display: inline-block;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: transparent;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 0 1px inset var(--answer-color);
  box-shadow: 0 0 0 1px inset var(--answer-color);
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.swpoll-close:hover {
  -webkit-box-shadow: 0 0 0 2px inset var(--answer-color);
  box-shadow: 0 0 0 2px inset var(--answer-color);
  cursor: pointer;
}
</style>
